<template>
    <v-row class="mt-1ml-0 ml-md-0 ml-sm-1 ml-xs-3 mb-0 mr-0 pa-0">
        <p v-if="showMatches || $route.name == 'infos'" class="ml-3  mb-3 mt-2 py-0 text-caption font-weight-bold">
            <span v-if ="matches < 900"> {{matches}} matches </span>
            <span v-else>More than 900 matches. Please refine your research.</span>
        </p>
        <p v-else class="ml-3  mb-5 mt-2 py-0 text-caption font-weight-bold">
            <span v-if = "matches == 0"> {{matches}} matches </span>
        </p>
        <v-card   v-for="publication in publications" :key="publication.id" min-width="100%"
            :class="['my-1',{'productionsm':mdAndDown}, {'production':!mdAndDown},'type'+publication.type ]" >
            <v-card-text class="ma-0">
                <v-row class="ma-0">
                    <v-col  class="d-flex my-0" cols="12" md="2" lg="2" xl="1" >
                        <app-publication-pattern :publication="publication" :bo="bo"></app-publication-pattern>
                    </v-col>
                    <v-col  class="d-flex my-0 pt-0 pb-1" cols="12" md="10" lg="10" xl="11" >
                        <app-publication-content :publication="publication" :bo="bo"></app-publication-content>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card v-if="showMore" :key="nbBlocks" flat min-width="100%" class="mb-4">
            <div v-for="(block, index,key) in blocks.slice(0, nbBlocks)" :key="index">
                <v-btn v-show="hiddenMoreBtn[index] !== true"  block  height="50" class=" grey darken-3 text-center white--text"
                    @click="getMore(index)"
                    :loading="loading"
                    :disabled="loading"
                    :key="index+'btn'">
                    <v-icon>mdi-dots-horizontal-circle</v-icon>
                    <span class="pl-6 subtitle-1 font-weight-black">MORE</span>
                </v-btn>
                <div v-if="hiddenMoreBtn[index]" :key="index+'div'">
                    <publications-list-more :index="index" :bo="bo"></publications-list-more>
                </div>
            </div>
        </v-card>
    </v-row>
</template>
<script>
import router from '../../../router';
import publicationPattern from './PublicationPattern.vue';
import publicationContent from './PublicationContent.vue';
import publicationsListMore from './PublicationsListMore.vue';

import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';

export default {
    props: {
        bo: {type:Boolean,
        default:false
        },
        typeProduction:{type:String},
    },
    metaInfo() {
        return{
            title: "Research IM",
            meta: [
                {vmid: "keywords", name: "keywords",content:  "journal paper, book, paper in proceedings,book chapter, preprint, thesis, lectures "}
            ]
        }
    },
    data() {
        return {
            showMorePublications: [0],
            blocks: [],
            hiddenMoreBtn: [], // Change from array to object
            loading: false ,
        };
    },
    created() {
        console.table(this.$route);
        for (let i = 0; i < this.nbBlocks; i++) {
            if (i>0){
                this.$set(this.hiddenMoreBtn, i, false);
            }
            
        }
    },
    components:{
        AppPublicationPattern:publicationPattern,
        AppPublicationContent:publicationContent,
        PublicationsListMore:publicationsListMore,
    },
    computed: {
        ...mapGetters('publication',{
            listTypePublication:'listTypePublication' ,
            publications:'publications',
            matches:'matches',
            showMatches:'showMatches',
            loading:'loading',
            year:'year',
            showMore:'showMore',
            nbBlocks:'nbBlocks'
        }),
        ...mapGetters('header',{
            mdAndDown:'mdAndDown',
        }),
    },
    methods:{
        ...mapActions('publication',{
            setMorePublications:'setMorePublications',
        }),
        getMore(index) {
            if (index < this.nbBlocks) {
                 // Add a new block
                this.blocks.push(1);
                // Show the loading spinner immediately
                this.$set(this, 'loading', true);
                // Hide current button immediately
                this.$set(this.hiddenMoreBtn, index, true);
                // Delay API request slightly to ensure spinner is visible
                setTimeout(() => {
                    this.setMorePublications(index).then(() => {
                        if (index < this.nbBlocks - 1) {
                            if (!Object.prototype.hasOwnProperty.call(this.hiddenMoreBtn, index + 1)) {
                                this.$set(this.hiddenMoreBtn, index + 1, false);
                            }
                        }
                        // Ensure spinner stays visible for at least 2 seconds
                        setTimeout(() => {
                            this.$set(this, 'loading', false);
                        }, Math.max(2000 - 500, 0)); // Adjusted timing to account for initial delay
                    });
                }, 500); // Small delay before fetching data (ensures UI updates)
                
                // this.$nextTick(() => {
                //     console.table(this.hiddenMoreBtn);
                // });
            }
        }
    }, 
    watch: {
        nbBlocks: function (val) {
            this.hiddenMoreBtn = [],
            this.blocks = [];
            if(this.showMore){
                this.blocks.push(1);
                this.$set(this.hiddenMoreBtn, 0, false); // Ensure reactivity
            }
        }
    },

}
</script>
<style  scoped>
.production{
  border-left-width: 0.7em;
  border-left-style: solid;
}
.productionsm{
  border-left-width:0.3em;
  border-left-style: solid;
}
.type1{
  border-left-color:#5C6BC0
}
.type2{
  border-left-color: rgb(247, 85, 85);
}
.type3{
  border-left-color: green
}
.type4{
  border-left-color: yellow
}
.type5{
  border-left-color: rgb(146, 245, 245)
}
.type6{
  border-left-color: rgb(175, 96, 26)
}
.type7{
  border-left-color: rgb(93, 109, 126 )
}
.type8{
  border-left-color: rgb(100,100,100)
}
</style>


